import type { OrganizationEditButtonProps } from "./organization-edit-button.type";

import { OrganizationEdit } from "@/features/Organizations/OrganizationEdit";
import { useAuthorization } from "@/modules/authorization";
import ModelEditButton from "@/modules/model-edit-button";
import { useSidePanel } from "@/modules/side-panel";

export const OrganizationEditButton = ({
  organization,
  ...buttonProps
}: OrganizationEditButtonProps) => {
  const { openSidePanel } = useSidePanel();
  const { canUpdateItem } = useAuthorization();

  const onClick = () => {
    openSidePanel({
      title: organization.name,
      component: <OrganizationEdit organizationId={organization.id} />,
    });
  };

  if (!canUpdateItem(organization)) return null;

  return (
    <ModelEditButton
      type="text"
      icon={null}
      {...buttonProps}
      item={organization}
      onClick={onClick}
    />
  );
};
